import { SurveyConfigurationType, SurveyRespondentIdentifyBy, SurveyResponseMode } from "@/common/interfaces";

export declare type StoredBoardLoadedState = 'info' | 'columns' | 'configuration' | 'participants';

export class Configuration {
	identifyBy: SurveyRespondentIdentifyBy = SurveyRespondentIdentifyBy.IP_ADDRESS;
	allowMultipleResponses: boolean = false;
	closeDate: Date | null = null;
	redirectUrl: string = '';
	password: string = '';
	opengraphTitle: string = '';
	opengraphDescription: string = '';
	showProgressBar: boolean = true;
	showPoweredBy: boolean = true;
	hideFromSearchIndex: boolean = false;
	responseMode: SurveyResponseMode = SurveyResponseMode.ONCE_PER_DEVICE;

	constructor(configuration: SurveyConfigurationType) {
		this.fromConfigurationType(configuration);
	}

	fromConfigurationType(configuration: SurveyConfigurationType) {
		this.identifyBy = configuration.identifyBy;
		this.allowMultipleResponses = configuration.allowMultipleResponses;
		this.redirectUrl = (configuration.redirectUrl)? configuration.redirectUrl : '';
		this.password = (configuration.password)? configuration.password : '';
		this.opengraphTitle = (configuration.opengraphTitle)? configuration.opengraphTitle : '';
		this.opengraphDescription = (configuration.opengraphDescription)? configuration.opengraphDescription : '';
		this.showProgressBar = configuration.showProgressBar;
		this.showPoweredBy = configuration.showPoweredBy;
		this.hideFromSearchIndex = configuration.hideFromSearchIndex;
		this.responseMode = configuration.responseMode;

		if (configuration.closeDate !== null) {
			this.closeDate = new Date(
				Date.parse(configuration.closeDate)
			);
		}
	}

	update(configuration: SurveyConfigurationType) {
		this.fromConfigurationType(configuration);
	}
}
